import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    myStaked: `My staked {token}`,
    annualEarning: 'Annual {token} earning',
    availableToStake: 'Available {token} to stake',
    apy: 'APY {apy}%',
    buyMore: '+ Buy More',
  },
};
